import React from 'react';
import styles from '../../Payments.module.css';
import { CheckIcon } from '../../icons';

const FeatureBlocks = () => (
  <>
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />However you sell</span>
            <h2>Get paid however you sell.</h2>
            <p>You don&apos;t need a developer or a storefront. Take payments with a shareable link, a hosted checkout page, a Pay Now button on an invoice, or a QR code for in-person — all from the same Fyntiq account.</p>
            <ul className={styles.fList}>
              {['Shareable payment links', 'Hosted checkout pages', 'Pay Now button on invoices', 'QR codes for in-person'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Ways to collect</div>
              <span className={styles.invLab}>CHOOSE ANY</span>
            </div>
            {[
              ['Payment link', 'pay.fyntiq.com/northbeam'],
              ['Hosted checkout', 'Branded page'],
              ['On an invoice', 'Pay Now button'],
              ['QR code', 'In person'],
            ].map(([name, meta]) => (
              <div key={name} className={styles.recItem}>
                <span className={`${styles.recDot} ${styles.recDotOn}`} />
                <div className={styles.recFlex}><div className={styles.recName}>{name}</div><div className={styles.recMeta}>{meta}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Speed</span>
            <h2>Same-day payouts with Fyntiq Wallet.</h2>
            <p>When customers pay with Fyntiq Wallet, the money can reach you the same day — instead of waiting on card-network settlement. Cards and bank transfers settle in about two business days, with one clear descriptor on every statement.</p>
            <ul className={styles.fList}>
              {['Same-day payouts on Fyntiq Wallet', '~2 business days for cards & bank', 'One clear statement descriptor', 'Track every payout in your dashboard'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>PAYOUT</div><div className={styles.invNum}>Fyntiq Wallet</div></div>
              <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Same day</span>
            </div>
            <div className={styles.invRow}><span>Paid by customer</span><span className={styles.mono}>Today, 9:41a</span></div>
            <div className={styles.invRow}><span>Deposited to you</span><span className={styles.mono}>Today</span></div>
            <div className={styles.invTotal}><span>Amount</span><span className={styles.mono}>$1,240.00</span></div>
            <div className={styles.invPaynow} style={{ background: 'var(--green)' }}>Deposited ✓</div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FeatureBlocks;
